import React, {useState} from "react";
// Import Swiper React components

// Import Swiper styles
import img1 from "../Banner/assets/thum.png";
import img2 from "../Banner/assets/thum2.png";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import right from "../assets/arrow-right.png";
import left from "../assets/arrow-left.png";
// import required modules
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination, Navigation } from "swiper";
import NftCard from "../../../GlobalComponents/NftCard/NftCard";
import { Link } from "react-router-dom";
const LiveAuctions = () => {
  const handleExp = () => {
    window.location.href = "/explore";
  };
  const breakpoints = {
    0: { slidesPerView: 1 },
    480: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1080: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    1440: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
    1640: {
      slidesPerView: 5,
      spaceBetween: 30,
    },
    1920: {
      slidesPerView: 5.5,
      spaceBetween: 30,
    },
  };
  return (
    <div className="pt-[60px] bg-custom-gradient liveAuctions px-2 md:px-0 ">
      <div className="container">
        <div className="max-w-[1410px] flex justify-between items-center">
          <h1 className=" font-bold text-[28px] md:leading-[44px] md:text-[36px] l leading-[44px] text-main-black">
            Live Auctions
          </h1>
          <button
            onClick={handleExp}
            className="bg-[#09090A] w-40 h-10 border rounded-[20px] border-solid border-white font-semibold text-[18px] leading-[18px]"
          >
            {" "}
            Explore more
          </button>
        </div>
      </div>
      <div className="mt-[40px] pb-[33px] relative">
        <Swiper
          slidesPerView={2}
          breakpoints={breakpoints}
          spaceBetween={30}
          freeMode={true}
          navigation={{
            nextEl: ".image-swiper-button-next",
            prevEl: ".image-swiper-button-prev",
          }}
          centeredSlidesBounds={true}
          initialSlide={5}
          pagination={{
            clickable: true,
          }}
          modules={[FreeMode, Pagination, Navigation]}
          className="mySwiper"
        >
          <SwiperSlide className=" custome-slide-style">
            <NftCard thum={img1}></NftCard>
          </SwiperSlide>

          <SwiperSlide className=" custome-slide-style">
            <NftCard gold={true} thum={img2}></NftCard>
          </SwiperSlide>
          <SwiperSlide className=" custome-slide-style">
            <NftCard thum={img1}></NftCard>
          </SwiperSlide>

          <SwiperSlide className=" custome-slide-style">
            <NftCard gold={true} thum={img2}></NftCard>
          </SwiperSlide>
          <SwiperSlide className=" custome-slide-style">
            <NftCard thum={img1}></NftCard>
          </SwiperSlide>

          <SwiperSlide className=" custome-slide-style">
            <NftCard gold={true} thum={img2}></NftCard>
          </SwiperSlide>
          <SwiperSlide className=" custome-slide-style">
            <NftCard thum={img1}></NftCard>
          </SwiperSlide>

          <SwiperSlide className=" custome-slide-style">
            <NftCard gold={true} thum={img2}></NftCard>
          </SwiperSlide>
        </Swiper>
        <div className="image-swiper-button-prev   absolute  left-[15%] lg:left-[40%] 4xl:left-[47%] 4xl:ml-[-19px] bottom-[49px]   z-10 cursor-pointer">
          <img src={left} alt="" />
        </div>
        <div className="image-swiper-button-next  absolute  right-[15%] lg:right-[40%] 4xl:right-[47%] 4xl:mr-[-19px] bottom-[49px]   z-10 cursor-pointer">
          <img src={right} alt="" />
        </div>
      </div>
    </div>
  );
};

export default LiveAuctions;
